/*** IMPORTS FROM imports-loader ***/
var define = false;

import lazySizes from 'lazysizes';

lazySizes.cfg.lazyClass = 'lazy';

